module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img47.003c6486.jpg";